import { fetchGet } from "../api/fetch";

export const fetchVerification = async (eventId) => {
  if (eventId) {
    try {
      const res = await fetchGet(`events/${eventId}/verification`);
      return res;
    } catch (e) {
      console.log(e);
    }
  }
  return null;
};
